import React, { useEffect } from "react";
import "./About.css";
import WOW from "wowjs";

const About = () => {
  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  return (
    <section
      id="about"
      class="page-section wow slideInLeft"
      data-wow-delay=".1"
    >
      <div class="more-about-us">
        <div class="container">
          <div class="col-md-12 center">
            <div class="content">
              <div class="container">
                <div
                  class="page-header text-center wow fadeInDown"
                  data-wow-delay="0.4s"
                >
                  <h2 style={{ color: "#ffc900", fontSize: "50px" }}>
                    About Us
                  </h2>
                  <div class="devider"></div>
                  <p style={{ color: "grey" }}>Behind the Business</p>
                </div>
              </div>
              <p style={{ color: "#faebd7" }}>
                PJ DIESEL SPECIALISTS is built out of the love of mechanics.
                Mechanics is not a job to us, it is our passion. We love engines
                and we take it seriously.
                <br />
                <br />
                Our responsibility is to provide good quality services to keep
                your machines running, with good customer care as our
                foundation.
                <br />
                <br />
                We thrive to work professionally whilst still providing custom
                tailored services for our customers as we believe that everyone
                of them is unique.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div
          class="page-header text-center wow fadeInDown"
          data-wow-delay="0.4s"
        >
          <h2 style={{ color: "#ffc900" }}>Our Values</h2>
          <div class="devider"></div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div
            class="col-md-3 col-sm-6 col-xs-12 wow slideInUp"
            data-wow-delay="5"
          >
            <div class="service-item">
              <div class="icon">
                <i class="fa fa-handshake fa-4x" aria-hidden="true"></i>
              </div>
              <h4 style={{ color: "#ffc900", fontSize: "25px" }}>Trust</h4>
              <div class="line-dec"></div>
              <p style={{ color: "#faebd7" }}>
                This is core to all what we do, we trust our customers, we trust
                our suppliers and we build trust in them.
              </p>
            </div>
          </div>
          <div
            class="col-md-3 col-sm-6 col-xs-12 wow slideInUp"
            data-wow-delay="9"
          >
            <div class="service-item">
              <div class="icon">
                <i class="fa fa-cog fa-4x" aria-hidden="true"></i>
              </div>
              <h4 style={{ color: "#ffc900", fontSize: "25px" }}>
                Intergrity
              </h4>
              <div class="line-dec"></div>
              <p style={{ color: "#faebd7" }}>
                The strong quality of being honesty, ethical and moral define
                our DNA
              </p>
            </div>
          </div>
          <div
            class="col-md-3 col-sm-6 col-xs-12 wow slideInUp"
            data-wow-delay="13"
          >
            <div class="service-item">
              <div class="icon">
                <i class="fa fa-fire fa-4x" aria-hidden="true"></i>
              </div>
              <h4 style={{ color: "#ffc900", fontSize: "25px" }}>Passion</h4>
              <div class="line-dec"></div>
              <p style={{ color: "#faebd7" }}>We apply our heart and mind </p>
            </div>
          </div>
          <div
            class="col-md-3 col-sm-6 col-xs-12 wow slideInUp"
            data-wow-delay="17"
          >
            <div class="service-item">
              <div class="icon">
                <i class="fa fa-heart fa-4x " aria-hidden="true"></i>
              </div>
              <h4 style={{ color: "#ffc900", fontSize: "25px" }}>Care</h4>
              <div class="line-dec"></div>
              <p style={{ color: "#faebd7" }}>
                We care for your engines, we care for our customers, we care for
                our employees and we care for the our ecosystem.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default About;
